// src/features/auth/register/components/AgreementField.jsx

import { MdArticle } from 'react-icons/md';
import styles from '../Register.module.css';
import agreementStyles from '../styles/AgreementField.module.css';

const AgreementField = ({
    checked,
    onChange,
    error,
    loading,
    canAcceptAgreement,
    termsRead,
    privacyRead,
    onOpenTerms,
    onOpenPrivacy,
    documentsLoading,
}) => {
    return (
        <div className={`${styles.field} ${agreementStyles.agreementField}`}>
            <label className={styles.label}>Persetujuan</label>

            <div className={agreementStyles.agreementCard}>
                <div className={agreementStyles.agreementHeader}>
                    <div className={agreementStyles.agreementTitleWrap}>
                        <MdArticle className={agreementStyles.agreementIcon} />
                        <div>
                            <p className={agreementStyles.agreementTitle}>Baca dokumen legal terlebih dahulu</p>
                            <p className={agreementStyles.agreementSubtitle}>
                                Klik tiap dokumen untuk membaca dokumen, gulir sampai akhir, lalu konfirmasi telah
                                membaca untuk dapat melanjutkan registrasi.
                            </p>
                        </div>
                    </div>

                    <div className={agreementStyles.agreementStatusRow}>
                        <span
                            className={`${agreementStyles.statusPill} ${
                                termsRead ? agreementStyles.statusPillDone : ''
                            }`}
                        >
                            {termsRead ? 'S&K dibaca' : 'S&K belum dibaca'}
                        </span>

                        <span
                            className={`${agreementStyles.statusPill} ${
                                privacyRead ? agreementStyles.statusPillDone : ''
                            }`}
                        >
                            {privacyRead ? 'Privasi dibaca' : 'Privasi belum dibaca'}
                        </span>
                    </div>
                </div>

                <div className={agreementStyles.agreementLinks}>
                    <button
                        type="button"
                        className={agreementStyles.inlineLinkBtn}
                        onClick={onOpenTerms}
                        disabled={documentsLoading}
                    >
                        Syarat dan Ketentuan
                    </button>

                    <span className={agreementStyles.linkSeparator}>dan</span>

                    <button
                        type="button"
                        className={agreementStyles.inlineLinkBtn}
                        onClick={onOpenPrivacy}
                        disabled={documentsLoading}
                    >
                        Kebijakan Privasi
                    </button>
                </div>

                <label
                    className={`${agreementStyles.checkboxCard} ${
                        !canAcceptAgreement ? agreementStyles.checkboxDisabled : ''
                    }`}
                >
                    <input
                        type="checkbox"
                        name="agreeTerms"
                        checked={checked}
                        onChange={onChange}
                        disabled={loading || !canAcceptAgreement}
                    />
                    <span>Saya menyetujui dokumen legal di atas</span>
                </label>

                {!canAcceptAgreement && (
                    <p className={agreementStyles.agreementHelpText}>
                        Checkbox akan aktif setelah Anda membaca kedua dokumen.
                    </p>
                )}

                {error && <span className={agreementStyles.fieldError}>{error}</span>}
            </div>
        </div>
    );
};

export default AgreementField;
